import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IAddInventoryResponse, IAddInventoryResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useGetProductCostAPI = () => {
  const [productCost, setProductCost] = useState<IAddInventoryResponseData>();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (variant_id: string,clinic_id:string): Promise<number | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${INVENTORY_MODULE?.GET_PRODUCT_COST?.baseURL}${variant_id}/?clinic_id=${clinic_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAddInventoryResponse>) => {
            if (res.data.status && res.data.data?.price_per_package !== undefined) {
              setProductCost(res.data.data);
              return res.data.data.price_per_package; // Ensure this is a number
            } else {
              setProductCost(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setProductCost(null);
            sendCurl(e.config["curlCommand"]);
            return null;
          });
        return response;
      } catch (error) {
        setProductCost(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
        return null;
      }
    },
    [configuration],
  );

  return { execute, productCost };
};
